<template lang="pug">
    //- Barra de filtros de búsqueda
    .b2b-filters
        b2b-search-bar
            div.header(slot='header')
              <span class='dateHeader'> {{ $t('invoices.filters.creation_date.value') }}</span>
              ods-date-picker(
                v-model='dateTimePickerValue',
                type='datetimerange',
                :picker-options='pickerOptions2',
                @change='getDateTimePickerValue',
                :range-separator='$t("msg_generics.datepicker.separator")',
                :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                :format='$t("date_format_long_datepicker")',
                :canSelectSeconds='true',
                clearIcon='',
                :default-time="['00:00:00', '23:59:59']",
                prefix-icon='prefix-icon-date-time-picker',
                :showFooterButtons='true',
                align='right')
              ods-tooltip.ods-ml-4(:content='$t("buttons.refresh_tooltip")', placement='bottom')
                ods-button(
                  icon='ods-icon-refresh',
                  size='medium',
                  circle,
                  @click="activeRefreshResults")
            div(slot='body')
                ods-form.b2b-filters__area(
                    :model='filterForm',
                    :rules='rules',
                    ref='filterForm',
                    @submit.native.prevent='')

                    ods-form-item.first-input(prop='firstValue')
                        ods-select(
                            :no-match-text='$t("msg_generics.no_match")',
                            v-model='filterForm.firstValue',
                            :placeholder='$t("msg_generics.advanced_search")',
                            @change='getFirstValue')
                            ods-option(
                                v-for='option in options',
                                :key='option.col',
                                :label='$t(option.value)',
                                :disabled='option.selected',
                                :value='option')
                    transition(name='ods-fade-in-linear', mode='out-in')
                      div(v-show='filterForm.firstValue')
                        //- Select type
                        div(v-if="(selected.componente === 'select' && selected.prop !== 'senderId' && selected.prop !== 'statusId')")
                            ods-form-item.others-input(prop='secondValueSelect')
                                ods-select(v-if="selected.prop === 'projectId'"
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                        v-for='option in selected.options',
                                        :key='option.id',
                                        :label='option.name',
                                        :value='option.id')
                                ods-select(v-else-if="selected.prop === 'receiverId'",
                                  :no-match-text='$t("msg_generics.no_match")',
                                  v-model='filterForm.secondValueSelect',
                                  filterable,
                                  :filter-method='filterPartiesReceiver',
                                  :placeholder='$t(selected.placeholder)',
                                  @change='getSecondValue')
                                  ods-option(
                                    v-for='option in selected.options',
                                    :key='option.id',
                                    :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                                    :value='option.id')
                                ods-select(v-else
                                    :no-match-text='$t("msg_generics.no_match")',
                                    v-model='filterForm.secondValueSelect',
                                    filterable,
                                    :placeholder='$t(selected.placeholder)',
                                    @change='getSecondValue')
                                    ods-option(
                                      v-for='option in selected.options',
                                      :key='option.id',
                                      :label='formatterLabel(option.code)',
                                      :value='option.id')
                        //-Exclusivo senderId
                        div(v-else-if="(selected.componente === 'select' && selected.prop === 'senderId')")
                          ods-form-item.others-input(prop='secondValueSelect')
                            div(v-if="(userLoggedOneProjectOneParty || userLoggedOneProjectOnePartyOneCentre)")
                              ods-tooltip( placement="top")
                                template(slot='content')
                                  | {{this.optionsFilterSenderCmrEmit[0].tradeName}}
                                ods-select(
                                  :no-match-text='$t("msg_generics.no_match")',
                                  v-model='filterForm.secondValueSelect',
                                  :placeholder='$t(selected.placeholder)',
                                  :disabled='true')
                                  ods-option(
                                    v-for='option in selected.options',
                                    :key='option.id',
                                    :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                                    :value='option.id')
                            div(v-else)
                              ods-select(
                                :no-match-text='$t("msg_generics.no_match")',
                                v-model='filterForm.secondValueSelect',
                                filterable,
                                :filter-method='filterPartiesSender',
                                :placeholder='$t(selected.placeholder)',
                                @change='getSecondValue')
                                ods-option(
                                    v-for='option in selected.options',
                                    :key='option.id',
                                    :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                                    :value='option.id')
                        div(v-else-if="(selected.componente === 'select' && selected.prop === 'statusId')")
                          ods-form-item.others-input(prop='secondValueSelectMultiple')
                            ods-select(v-if="selected.prop === 'statusId'",
                              :no-match-text='$t("msg_generics.no_match")',
                              v-model='filterForm.secondValueSelectMultiple',
                              filterable
                              multiple,
                              collapse-tags,
                              :placeholder='$t(selected.placeholder)',
                              @change='getSecondValue')
                              ods-option(
                                v-for='option in selected.options',
                                :key='option.id',
                                :label='$t("cmr_status." + option.status)',
                                :value='option.id')
                            div(v-else)
                              ods-select(
                                :no-match-text='$t("msg_generics.no_match")',
                                v-model='filterForm.secondValueSelect',
                                filterable,
                                :filter-method='filterPartiesSender',
                                :placeholder='$t(selected.placeholder)',
                                @change='getSecondValue')
                                ods-option(
                                  v-for='option in selected.options',
                                  :key='option.id',
                                  :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                                  :value='option.id')
                        //- CMR NUMBER
                        div(v-else-if="selected.componente === 'input' && (selected.prop === 'cmrNumber')")
                          ods-form-item.others-input(prop='cmrNumber')
                            ods-input(
                              :placeholder='$t(selected.placeholder)',
                              v-model.trim='filterForm.cmrNumber',
                              @input='getSecondValue')
                        //- Date Type
                        div(v-else-if='selected.componente === "daterange"')
                          ods-form-item(prop='filterDatePickerValue')
                            ods-date-picker(
                              v-model='filterForm.filterDatePickerValue',
                              type='daterange',
                              :picker-options='pickerOptions2',
                              @change='getDateRangePickerValue',
                              :range-separator='$t("msg_generics.datepicker.separator")',
                              :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                              :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                              :format='$t("date_format_calendar")',
                              prefix-icon='prefix-icon-date-time-picker',
                              align='right')

                        div(v-else-if='selected.componente === "datetimerange" && (selected.prop !== "dateTimePickerValue")')
                          ods-form-item(prop='filterDeliveryDatePickerValue')
                          ods-date-picker(
                            v-model='filterForm.filterDeliveryDatePickerValue',
                            type='datetimerange',
                            :picker-options='pickerOptions2',
                            @change='getDeliveryDateRangePickerValue',
                            :range-separator='$t("msg_generics.datepicker.separator")',
                            :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                            :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                            :format='$t("date_format_long_datepicker")',
                            :canSelectSeconds='true',
                            :default-time="['00:00:00', '23:59:59']",
                            prefix-icon='prefix-icon-date-time-picker',
                            :showFooterButtons='true',
                            align='right')
                        //- Input type
                        div(v-else-if='selected.componente === "input" && (selected.prop !== "cmrNumber")')
                          ods-form-item.others-input(prop='secondValue')
                            ods-input(
                              :placeholder='$t(selected.placeholder)',
                              v-model='filterForm.secondValue',
                              @input='getSecondValue')
                        div(v-else)
                            ods-form-item(prop='secondValueNumber')
                                ods-input.others-input(
                                    :placeholder='$t(selected.placeholder)',
                                    v-model='filterForm.secondValueNumber',
                                    @input='getSecondValue')

                    transition(name='ods-fade-in-linear', mode='out-in')
                      div(v-show="(selected.prop === 'receiverId' || selected.prop === 'senderId') && filterForm.secondValueSelect")
                       ods-form-item.others-input(prop='thirdValueSelect')
                        ods-select(
                          v-if="(selected.prop === 'receiverId' && selectedReceiver)"
                          :no-match-text='$t("msg_generics.no_match")',
                          v-model='filterForm.thirdValueSelect',
                          multiple,
                          filterable,
                          collapse-tags,
                          :placeholder='$t(selectedCentre.placeholder)',
                          @change='getThirdValue')
                          ods-option(
                            v-for='option in selectedCentre.options',
                            :key='option.id',
                            :label='option.code',
                            :value='option.id')
                        ods-select(
                           v-if="(!this.userLoggedOneProjectOnePartyOneCentre && selected.prop === 'senderId' && (selectedSender || this.userLoggedOneProjectOneParty))"
                          :no-match-text='$t("msg_generics.no_match")',
                          v-model='filterForm.thirdValueSelect',
                          multiple,
                          filterable,
                          collapse-tags,
                          :placeholder='$t(selectedCentre.placeholder)',
                          @change='getThirdValue')
                          ods-option(
                            v-for='option in selectedCentre.options',
                            :key='option.id',
                            :label='option.code',
                            :value='option.id')
                        ods-tooltip(
                          v-if="(this.userLoggedOneProjectOnePartyOneCentre && selected.prop === 'senderId')"
                          placement="top")
                          template(slot='content')
                            | {{ centreUser.code }}
                          ods-input.others-input(
                            v-model='centreUser.code',
                            :disabled='true')
                    transition(name='ods-fade-in-linear', mode='out-in')
                      div(v-show='filterForm.firstValue')
                        ods-button(
                          :disabled="!activeButtonAddFilter"
                          icon='ods-icon-plus',
                          size='medium',
                          circle,
                          @click.native="onSubmit('filterForm')")

        .b2b-filters__container(v-if='listSelectedFiltersCmrEmit.length > 0')
          transition-group.b2b-filters__group(
            name='ods-fade-in-linear',
            tag='div')
            ods-popover(
              key='icon-delete-filters',
              placement='top-start',
              trigger='hover',
              :content='$t("msg_generics.popover_clean_filters")')
              ods-button.clean-filters(
                slot='reference',
                type='neutral',
                size='small',
                icon='ods-icon-delete'
                @click='handleDeleteAllFilters')

            .b2b-filters__button(
              v-for='(filter, index) in listSelectedFiltersCmrEmit',
              :key='index')
              b2b-filter-button-cmr-emit(
                :filter='filter',
                @closeTag='resetSelectedOneOption')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bSearchBar from '@/components/B2bSearchBar'
import B2bFilterButtonCmrEmit from '@/views/cmr/emitidos/B2bFilterButtonCmrEmit'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filters-cmr-emit',

  props: {
    filterOptions: {
      type: Object,
      required: true
    }
  },

  mixins: [Utils],

  components: {
    B2bSearchBar,
    B2bFilterButtonCmrEmit
  },

  data () {
    const _this = this
    const checkNumber = (rule, value, callback) => {
      if (!this.checkCorrectNumber(value)) {
        callback(new Error(this.$t('msg_generics.format_invalid')))
      } else if (this.countDecimals(value) > 6) {
        callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
      }
      callback()
    }
    return {
      activeButtonAddFilter: true,
      userLoggedOneProjectOneParty: false, // Flag que nos indica si el usuario tiene 1 solo proyecto y una sola empresa
      userLoggedOneProjectOnePartyOneCentre: false, // Flag que nos indica si el usuario tiene 1  proyecto 1 empresa 1 centro
      selectedReceiver: false, // Flag que indica cuando tienen que mostrarse los centros de entrega
      selectedSender: false, // Flag que indica cuando tienen que mostrarse los centros carga
      // DatePicker
      dateTimePickerValue: [],
      filterDatePickerValue: [],
      filterDeliveryDatePickerValue: [],
      pickerOptions2: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('msg_generics.datepicker.today'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'today')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_week'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastWeek')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_month'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastMonth')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_three_months'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastThreeMonths')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastYear')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_two_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastTwoYear')
            }
          }
        ]
      },

      // Forumlario
      filterForm: {
        firstValue: '',
        secondValue: '',
        filterDateFromTo: null,
        secondValueNumber: '',
        secondValueSelect: [],
        thirdValueSelect: [],
        cmrNumber: '',
        secondValueSelectMultiple: []
      },
      tid: null,
      selected: {},
      selectedCentre: {},
      selectedFilters: [],
      options: {},
      auxListPartiesReceiver: [],
      auxListPartiesSender: [],
      centreUser: {},

      // Reglas Validación
      rules: {
        cmrNumber: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 35, message: this.$t('msg_generics.max_num_character', { max: 35 }), trigger: 'change' }
        ],
        secondValue: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 50, message: this.$t('msg_generics.max_num_character', { max: 50 }), trigger: 'change' }
        ],
        secondValueNumber: [
          { required: true, message: this.$t('msg_generics.field_required') },
          { validator: checkNumber, trigger: 'change' }
        ],
        secondValueSelect: [
          {
            required: true,
            message: this.$t('msg_generics.element_selected'),
            trigger: 'change'
          }
        ],
        secondValueSelectMultiple: [
          {
            required: true,
            message: this.$t('msg_generics.element_selected'),
            trigger: 'click'
          }
        ],
        thirdValueSelect: [
          {
            required: this.firstValue === this.$t('cmr.filters.sender.value') || this.firstValue === this.$t('cmr.filters.receiver.value'),
            message: this.$t('msg_generics.element_selected'),
            trigger: 'change'
          }
        ]
      },
      servicios: []
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'queryCmrEmit',
      'listSelectedFiltersCmrEmit',
      'optionsFilterReceiverCmrEmit',
      'optionsFilterSenderCmrEmit',
      'optionsFilterService',
      'optionsFilterStatusCmr',
      'optionsFilterDateIssueCmrEmit',
      // Permisos
      'urlIn'
    ])

  },

  watch: {
    $route (to) {
      this.listSelectedFiltersCmrEmit = this.listSelectedFiltersCmrEmit // eslint-disable-line
    }
  },

  methods: {
    activeRefreshResults () {
      this.refreshResults()
    },
    ...mapActions([
      'getCmrNotes',
      'getOptionsService',
      'optionsServicesEnabledState',
      'queryCmrEmitState',
      'listSelectedFiltersCmrEmitState',
      'getOptionsFilterPartyMEFenixBackend',
      'optionsFilterReceiverCmrEmitState',
      'optionsFilterSenderCmrEmitState',
      'optionsFilterServiceState',
      'getOptionsFilterCentresOrderByEnabledFenixBackend',
      'getCentresByPartyFenixBackend',
      'getOptionsFilterStatusCmr'
    ]),

    formatterLabel (code) {
      const type = this.selected.prop
      let key
      switch (type) {
        case 'communicationMethodId':
          key = 'communication_method.'
          break
        case 'statusId':
          key = 'cmr_status.'
          break
      }
      return this.$t(key + code)
    },

    async getFirstValue (data) {
      this.filterForm.cmrNumber = ''
      this.filterForm.plate = ''
      this.filterForm.trailerPlate = ''
      this.filterForm.secondValue = ''
      this.filterForm.secondValueNumber = ''
      this.filterForm.secondValueSelect = ''
      this.filterForm.secondValueSelectMultiple = []
      this.filterForm.thirdValueSelect = []
      this.$refs.filterForm.clearValidate()
      this.selected = data

      if (data.prop === 'senderId') {
        this.activeButtonAddFilter = false
      } else if (data.prop === 'receiverId') {
        this.activeButtonAddFilter = false
      } else {
        this.activeButtonAddFilter = true
      }
      // Precarga de centro y empresa en el combo de vendedores, si procede
      // Se pueden dar 3 casuísticas distintas
      // 1.Usuario con 1 proyecto y 1 empresa y centros === null
      // 2.Usuario con 1 proyecto 1 empresa y 1 centro
      // 3.El resto de casos

      // No tiene 1 solo proyecto y 1 sola empresa.
      if (!this.userLoggedOneProjectOneParty) {
        // 3.El resto de casos
        this.optionsFilterSenderCmrEmitState([])
        this.optionsFilterReceiverCmrEmitState([])
        this.activeButtonAddFilter = true
      } else {
        // 1 proyecto - 1 empresa y 1 a N centros
        if (data.prop === 'senderId') {
          if (this.optionsFilterSenderCmrEmit.length > 0) {
            this.filterForm.secondValueSelect = this.optionsFilterSenderCmrEmit[0].tradeName
            this.selected.query = this.optionsFilterSenderCmrEmit[0].id
          }
          // 2.Usuario con 1 proyecto 1 empresa y un centro
          if (this.userLoggedOneProjectOnePartyOneCentre) {
            const load = this.$loading({
              lock: true
            })
            const data = {
              projectId: this.activeUser.data.projects[0].id,
              partyId: this.activeUser.data.projects[0].parties[0].id
            }
            try {
              const centroBd = await this.getCentresByPartyFenixBackend(data)
              this.centreUser = {
                id: centroBd[0].id,
                code: centroBd[0].code + '-' + centroBd[0].name,
                roles: centroBd[0].centreRoles
              }
              this.selected.labelText = centroBd[0].code
              this.filterForm.thirdValueSelect = this.centreUser.id
            } catch (error) {
              console.log('getCentresByPartyFenixBackend CATCH: ', error)
              this.getNotificationErrorMessage(error)
            } finally {
              load.close()
            }
            this.activeButtonAddFilter = false

          // 1.Usuario con 1 proyecto y 1 empresa y centros === null
          } else if (this.userLoggedOneProjectOneParty) {
            const party = {
              query: this.optionsFilterSenderCmrEmit[0].id,
              prop: 'senderId'
            }
            await this.getListCentres(party)
            this.selectedCentre = this.selected.centro_carga
            this.activeButtonAddFilter = true
          }
        }
      }
    },
    getSecondValue (data) {
      if (
        this.selected.componente === 'select' &&
        (this.selected.prop === 'projectId')
      ) {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = option.name
      } else if (this.selected.prop === 'statusId') {
        const self = this
        let description = ''
        const estados = this.selected.options

        for (let index = 0; index < data.length; index++) {
          const element = data[index]
          estados.find(function (elem) { // eslint-disable-line
            if (elem.id === element) {
              description += self.$t('cmr_status.' + elem.status)
              if (index < data.length - 1) {
                description += ','
              }
            }
          })
        }
        this.selected.labelText = description
      } else if (
        (this.selected.componente === 'select' &&
          this.selected.prop === 'receiverId') ||
        this.selected.prop === 'senderId'
      ) {
        const option = this.selected.options.find(function (elem) {
          return elem.id === data
        })
        this.selected.query = option.id
        this.selected.labelText = option.tradeName
        this.selected.partyId = this.selected.labelText
        // Obtenemos la lista de centros asociados al componente seleccionado, ya sea comprador o vendedor

        this.getListCentres(this.selected)
        if (this.selected.prop === 'receiverId') {
          this.selectedCentre = this.selected.receiver_centre
          this.selectedReceiver = true
        } else {
          this.selectedCentre = this.selected.sender_centre
          this.selectedSender = true
        }
        if (this.selectedCentre) {
          this.activeButtonAddFilter = true
        } else {
          this.activeButtonAddFilter = false
        }
      } else if (this.selected.componente === 'daterange' || this.selected.componente === 'date' || this.selected.componente === 'datetimerange') {
        this.selected.labelText = data.query
      } else {
        this.selected.query = data.id
        this.selected.labelText = data.code
        this.filterForm.secondValueSelect = data.code
      }

      if (this.selected.componente === 'input') {
        this.selected.query = data
        this.selected.labelText = data
      }
      this.$refs.filterForm.clearValidate()
    },

    getThirdValue (data) {
      let description = ''
      const labelCentres = this.$t('breadcrumb.administration_project_admin_centres')
      const centros = this.selected.prop === 'receiverId' ? this.selected.receiver_centre.options : this.selected.sender_centre.options

      for (let index = 0; index < data.length; index++) {
        const element = data[index]
        centros.find(function (centro) { // eslint-disable-line
          if (centro.id === element) {
            const aux = centro.code.split('-', 1)
            description += aux
            if (index < data.length - 1) {
              description += ','
            }
          }
        })
      }
      if (description.length > 35) {
        let shorterTag = description.slice(0, 35)
        shorterTag = shorterTag.slice(0, shorterTag.lastIndexOf(','))
        this.selected.labelText = this.selected.partyId + ' ' + labelCentres + ': ' + shorterTag + '...'
      } else {
        this.selected.labelText = this.selected.partyId + ' ' + labelCentres + ': ' + description
      }
    },

    // Metodo auxiliar para obtener la lista de centros asociados a unna empresa,ya sea compradora o vendedora
    async getListCentres (party) {
      const load = this.$loading({
        lock: true
      })
      const dataQuery = {
        idProject: this.queryCmrEmit.projectId,
        idParty: party.query,
        isBuyer: null,
        isSeller: null,
        isEnable: null,
        roles: null
      }
      try {
        if (party.prop === 'receiverId') {
          dataQuery.isBuyer = true
          this.options.receiver.receiver_centre.options = await this.getOptionsFilterCentresOrderByEnabledFenixBackend(dataQuery)
        } else {
          dataQuery.isSeller = true
          this.options.sender.sender_centre.options = await this.getOptionsFilterCentresOrderByEnabledFenixBackend(dataQuery)
        }
      } catch (error) {
        console.log('getListCentres CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Filtro Fechas Emision
    getDateRangePickerValue () {
      this.selected.query = this.filterForm.filterDatePickerValue
      this.getSecondValue(this.selected)
    },
    // Filtro Fechas Entrega
    getDeliveryDateRangePickerValue () {
      this.selected.query = this.filterForm.filterDeliveryDatePickerValue
      this.getSecondValue(this.selected)
    },
    onSubmit (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const dataQuery = {
            query: {}
          }
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.filter_selected')
          })
          try {
            console.log('1 Filtro Seleccionado: ', this.selected)
            const column = this.selected.prop
            console.log('column ', column)
            switch (column) {
              case 'receiverId':
                this.queryCmrEmit.receiverId = this.selected.query
                this.queryCmrEmit.receiverCentreId = this.filterForm.thirdValueSelect
                break
              case 'senderId':
                this.queryCmrEmit.senderId = this.selected.query
                this.queryCmrEmit.senderCentreId = this.filterForm.thirdValueSelect
                break
              case 'cmrNumber':
                this.queryCmrEmit.cmrNumber = this.selected.query.trim()
                break
              case 'plate':
                this.queryCmrEmit.plate = this.selected.query.trim()
                break
              case 'trailerPlate':
                this.queryCmrEmit.trailerPlate = this.selected.query.trim()
                break
              case 'projectId':
                this.queryCmrEmit.projectId = this.selected.query
                break
              case 'statusId':
                this.queryCmrEmit.statusId = this.filterForm.secondValueSelectMultiple
                break
              case 'sendDate':
                this.queryCmrEmit.sendDateFrom = this.selected.query[0]
                this.queryCmrEmit.sendDateTo = this.selected.query[1]
                break
              case 'transportist':
                this.queryCmrEmit.transportist = this.selected.query.trim()
                break
              default:
                break
            }
            this.selectedFilters = this.listSelectedFiltersCmrEmit
            console.log('FILTROS SELECCIONADOS: ', this.selectedFilters)

            this.selected.selected = true
            this.selectedFilters.push(this.selected)
            await this.listSelectedFiltersCmrEmitState(
              this.selectedFilters
            )

            this.selected = {}
            this.$refs[formName].resetFields()
            this.filterForm.filterDatePickerValue = []

            await this.queryCmrEmitState(this.queryCmrEmit)
            dataQuery.query = this.queryCmrEmit
            this.queryCmrEmit.page = 0
            const response = await this.getCmrNotes(dataQuery)
            this.totalResults = response.data.totalElements
          } catch (error) {
            console.log('onSubmit FILTER CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.handleDeleteAllFilters()
          } finally {
            this.initForm()
            load.close()
          }
        }
      })
    },

    async getDateTimePickerValue () {
      if (!this.dateTimePickerValue) {
        this.queryCmrEmit.creationDateTimeFrom = ''
        this.queryCmrEmit.creationDateTimeTo = ''
      } else {
        this.queryCmrEmit.creationDateTimeFrom = this.dateTimePickerValue[0]
        this.queryCmrEmit.creationDateTimeTo = this.dateTimePickerValue[1]
      }
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_date')
      })

      try {
        await this.queryCmrEmitState(this.queryCmrEmit)
        dataQuery.query = this.queryCmrEmit
        await this.getCmrNotes(dataQuery)
      } catch (error) {
        console.log('getDateTimePickerValue CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async refreshResults () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryCmrEmit.urlName = this.urlIn
        } else {
          this.queryCmrEmit.urlName = null
        }
        await this.queryCmrEmitState(this.queryCmrEmit)
        dataQuery.query = this.queryCmrEmit
        const response = await this.getCmrNotes(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('onSubmit FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleDeleteAllFilters () {
      console.log(this.selectedFilters)

      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete_all')
      })

      try {
        // Reseteamos la prop selected de los filtros
        this.resetSelectedOptions(this.options)
        await this.listSelectedFiltersCmrEmitState([])
        this.selectedFilters = this.listSelectedFiltersCmrEmit.map(
          item => {
            item.labelText = ''
            item.query = ''
            item.selected = false
            return item
          }
        )
        await this.listSelectedFiltersCmrEmitState(
          this.selectedFilters
        )

        if (!this.dateTimePickerValue) {
          this.queryCmrEmit.creationDateTimeFrom = ''
          this.queryCmrEmit.creationDateTimeTo = ''
        } else {
          this.queryCmrEmit.creationDateTimeFrom = this.dateTimePickerValue[0]
          this.queryCmrEmit.creationDateTimeTo = this.dateTimePickerValue[1]
        }

        this.queryCmrEmit.searchType = 'EMITTED'
        this.queryCmrEmit.receiverId = ''
        this.queryCmrEmit.senderId = ''
        this.queryCmrEmit.cmrNumber = ''
        this.queryCmrEmit.plate = ''
        this.queryCmrEmit.trailerPlate = ''
        this.queryCmrEmit.projectId = ''
        this.queryCmrEmit.statusId = ''
        this.queryCmrEmit.communicationMethodId = ''
        this.queryCmrEmit.orderNumber = ''
        this.queryCmrEmit.receiverCentreId = ''
        this.queryCmrEmit.senderCentreId = ''
        this.queryCmrEmit.issueDateTimeFrom = ''
        this.queryCmrEmit.issueDateTimeTo = ''
        this.queryCmrEmit.deliveryDateFrom = ''
        this.queryCmrEmit.deliveryDateTo = ''
        this.queryCmrEmit.sendDateFrom = ''
        this.queryCmrEmit.sendDateTo = ''
        this.queryCmrEmit.transportist = ''

        await this.queryCmrEmitState(this.queryCmrEmit)
        dataQuery.query = this.queryCmrEmit
        await this.getCmrNotes(dataQuery)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        this.initForm()
        load.close()
      }
    },
    async getReceiverResults (data) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      const requestParty = {
        role: 'BUYER',
        seller: false,
        emission: true,
        projectId: this.queryCmrEmit.projectId,
        page: 0,
        size: 10000,
        tradeNameOrTaxId: data
      }
      try {
        const response = await this.getOptionsFilterPartyMEFenixBackend(requestParty)
        this.filterForm.secondValueSelect = data
        this.auxListPartiesReceiver = response
        this.optionsFilterReceiverCmrEmitState(response)
      } catch (error) {
        console.log('filterPartiesReceiver CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async filterPartiesReceiver (data) {
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getReceiverResults, 1000, data)
        // Si el valor introducido tiene más de 3 caracteres, se filtra en la propia lista obtenida anteriormente
        } else {
          this.auxListPartiesReceiver = []
          this.optionsFilterReceiverCmrEmitState(this.auxListPartiesReceiver)
        }
      } catch (error) {
        console.log('filterPartiesReceiver CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async getSenderResults (data) {
      const load = this.$loading({
        lock: true
      })
      const requestParty = {
        role: 'SELLER',
        seller: false,
        emission: true,
        projectId: this.queryCmrEmit.projectId,
        page: 0,
        size: 10000,
        tradeNameOrTaxId: data
      }
      try {
        const response = await this.getOptionsFilterPartyMEFenixBackend(requestParty)
        this.filterForm.secondValueSelect = data
        this.auxListPartiesSender = response
        this.optionsFilterSenderCmrEmitState(response)
      } catch (error) {
        console.log('getSenderResults CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async filterPartiesSender (data) {
      // Si tiene 1 solo proyecto y 1 sola empresa no se permite el autocompletado
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getSenderResults, 1000, data)
          // Si el valor introducido tiene más de 3 caracteres, se filtra en la propia lista obtenida anteriormente
        } else {
          this.auxListPartiesSender = []
          this.optionsFilterSenderCmrEmitState(this.auxListPartiesSender)
        }
      } catch (error) {
        console.log('filterPartiesSender CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 404:
        case 409:
        case 415:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    },

    // Metodo lanzado al capturar el evento de closeTag
    async resetSelectedOneOption (data) {
      this.resetOneOption(this.options, data.filter)
      await this.listSelectedFiltersCmrEmitState(data.listAfterRemove)
      this.initForm()
    },

    // Metodo que nos indica el numero de proyectos-empresas y centros de un usuario
    getProjectPartiesCentres () {
      let numParties = 0
      let numProject = 0
      let numCentres = 0
      if (this.activeUser.data && this.activeUser.data.projects) {
        numProject = this.activeUser.data.projects.length
      }
      // Si el usuario logeado pertenece a un solo proyecto
      if (numProject === 1) {
        if (this.activeUser.data.projects[0].parties) {
          numParties = this.activeUser.data.projects[0].parties.length
        }
        // Si tiene una sola empresa
        if (numParties === 1) {
          const carga = {
            id: this.activeUser.data.projects[0].parties[0].id,
            tradeName: this.activeUser.data.projects[0].parties[0].name
          }
          // seteamos la empresa en el campo carga
          const lstSender = []
          lstSender.push(carga)
          this.optionsFilterSenderCmrEmitState(lstSender)
          // Activamos a true
          this.userLoggedOneProjectOneParty = true
          this.queryCmrEmit.senderId = carga.id

          // Si tiene un solo proyecto-centro y empresa
          if (this.activeUser.data.projects[0].parties[0].centres) {
            numCentres = this.activeUser.data.projects[0].parties[0].centres.length
            if (numCentres === 1) {
              // Activamos a true
              this.userLoggedOneProjectOnePartyOneCentre = true
            }
          }
        }
      }
      // console.log('Numero de proyectos =' + numProject + ' Numero de empresas =' + numParties + 'Numero de centros =' + numCentres)
    },

    initForm () {
      if (!this.options.cmr_number.selected) {
        this.filterForm.firstValue = this.options.cmr_number
        this.selected = this.filterForm.firstValue
      } else {
        this.filterForm.firstValue = ''
        this.selected = this.filterForm.firstValue
      }
    }
  },

  async created () {
    this.options = JSON.parse(JSON.stringify(this.filterOptions))

    // Ponemos el estado de selected a true si ya estaba seleccionado el filtro
    this.checkListFilterSelected(this.options, this.listSelectedFiltersCmrEmit)

    // Si tiene un solo servicio se quita el filtro
    if (this.optionsFilterService.length < 2) {
      delete this.options.servicio
    }
    if (this.activeUser.data.projects && this.activeUser.data.projects.length === 1) {
      this.queryCmrEmit.projectId = this.activeUser.data.projects[0].id
    }

    this.initForm()
    this.getProjectPartiesCentres()
    if (this.queryCmrEmit.creationDateTimeFrom) {
      this.dateTimePickerValue.push(this.queryCmrEmit.creationDateTimeFrom)
      this.dateTimePickerValue.push(this.queryCmrEmit.creationDateTimeTo)
    }
    try {
      await this.queryCmrEmitState(this.queryCmrEmit)
      // Combo estados
      await this.getOptionsFilterStatusCmr()
    } catch (error) {
      this.getNotificationErrorMessage(error)
    }
  },

  updated () {
    this.options.sender.options = this.optionsFilterSenderCmrEmit
    this.options.receiver.options = this.optionsFilterReceiverCmrEmit
    this.options.estado.options = this.optionsFilterStatusCmr

    if (this.optionsFilterService.length > 1 && this.options.servicio) {
      this.options.servicio.options = this.optionsFilterService
    }

    console.log('updated filters options after load services data: ', this.options)
    console.log('selected: ', this.selected)

    // this.options.fecha_emision.options = this.optionsFilterDateIssueCmrEmit
  }
}
</script>

<style lang="scss" scoped>

::v-deep .ods-select__tags {
  max-width: none !important;
}
::v-deep .b2b-filters__area .ods-form-item input {
  margin-bottom: rem(21) !important;
  height: 32px !important;
}

::v-deep .ods-select .ods-input.is-focus .ods-input__inner {
  height: 32px !important;
}
::v-deep .ods-input__prefix {
  height: 72px !important;
}
::v-deep .ods-input__suffix {
  height: 72px !important;
}
.b2b-filters{
  ::v-deep .ods-input__suffix {
    height: 72px;
  }
  ::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
  }
::v-deep .ods-icon-close, body .ods-icon-close {
    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -4px;
    color: var(--color-bg-interactive);
}

::v-deep .ods-tag {
    display: inline-block;
    height: 24px;
    line-height: 14px;
    background-color: white;
    padding-top: 5px;
    font-size: 9px;
    color: var(--color-bg-interactive);
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "微软雅黑", Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 1px solid;
}
::v-deep .ods-select .ods-tag {
    display: inline-flex;
    .ods-tag__content {
      .ods-select__tags-text {
        text-transform: none;
      }
      max-width: 100%;
    min-width: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: calc(100% - 8px);
    display: inline-block;
    vertical-align: bottom;
    }
  }
  .b2b-filters__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
  }
  // background-color: var(--color-bg-primary);
  // border-top: .1rem solid $grey-2;
  // box-shadow: 0 .2rem .8rem 0 rgba(0, 0, 0, 0.08);

  .dateHeader {
    font-size: 12px;
    padding: 0 28px 0 20px;
    color: var(--color-txt-secondary);
  }

  .ods-button{
    display: inline;
  }

  ::v-deep &__area {
    display: flex;

    .ods-form-item {
      margin-bottom: 0;
      &__content {
        line-height: inherit;
      }
      &__error {
        top: rem(55);
      }
      input {
        max-width: rem(200);
      }
      select {
        max-width: rem(200);
      }
    }

    .first-input {
      margin-right: rem(16);
    }

    // Para los input que no sean datepicker,
    // colocar un margen igual a como si tuviese el botón del datepicker
    .others-input {
      margin-right: rem(16);
    }

    .ods-range-separator {
      padding: 0 rem(8);
    }
  }

  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;

    .clean-filters {
      color: var(--color-status-info-400);
      .ods-icon-delete {
        margin-left: 0px;
      }
    }
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }
  ::v-deep .b2b-search-bar__header-right {
    margin-right: 2.5rem;
  }
  ::v-deep .ods-select .ods-tag {
    margin: 2px 0 -56px 6px;
  }
}
</style>
